import React, { useState } from 'react';
import { useTickets } from '../hooks/useTickets';
import { TicketList } from '../components/tickets/TicketList';
import { CreateTicketForm } from '../components/tickets/CreateTicketForm';
import { Ticket as TicketIcon, Plus, X } from 'lucide-react';
import { apiService } from '../services/api';
import { CreateTicketRequest } from '../types/api';

export function Tickets() {
  const { tickets, loading, error, refetch } = useTickets();
  const [showForm, setShowForm] = useState(false);
  const [creating, setCreating] = useState(false);

  const handleCreateTicket = async (request: CreateTicketRequest) => {
    setCreating(true);
    try {
      await apiService.createTickets(request);
      await refetch();
      setShowForm(false);
    } catch (err) {
      console.error('Failed to create ticket:', err);
      throw err;
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <TicketIcon className="h-8 w-8 text-blue-600" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Tickets</h1>
            <p className="text-gray-600 mt-1">Manage issues and tasks across repositories</p>
          </div>
        </div>

        <button
          onClick={() => setShowForm(!showForm)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          {showForm ? (
            <>
              <X className="h-5 w-5" />
              Close
            </>
          ) : (
            <>
              <Plus className="h-5 w-5" />
              Create Ticket
            </>
          )}
        </button>
      </div>

      {/* Create Ticket Form */}
      {showForm && <CreateTicketForm onSubmit={handleCreateTicket} loading={creating} />}

      {/* Ticket List */}
      <TicketList tickets={tickets} loading={loading} error={error} />
    </div>
  );
}
